<template>
  <svg class="inline-block w-[1em] h-[1em] fill-current leading-none">
    <use :xlink:href="`#${id}`" />
  </svg>
</template>

<script lang="ts" setup>
const { id } = defineProps<{
  id: Icon
}>()
</script>